// Configuration de l'agence — 100 % modifiable via /parametres
// Prototype visuel : cette config sera stockée en base côté backend.

export const AGENCY = {
  name: "SimpliciCar Toulon Est",
  tagline: "Centre de pilotage",
  logo: null, // future upload → remplace le mark
  initials: "ST",
  phone: "+33 4 94 12 34 56",
  email: "contact@simplicicar-toulon.fr",
  address: "125 avenue de la République, 83000 Toulon",
  primaryColor: "#C8FF2F",
  // Utilisateur connecté (référent commercial)
  user: {
    name: "Stéphane Marchand",
    role: "Directeur commercial",
    initials: "SM",
  },
};
